import { render, staticRenderFns } from "./OptionCategory.vue?vue&type=template&id=b40d9b32&scoped=true"
import script from "./OptionCategory.vue?vue&type=script&lang=js"
export * from "./OptionCategory.vue?vue&type=script&lang=js"
import style0 from "./OptionCategory.vue?vue&type=style&index=0&id=b40d9b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40d9b32",
  null
  
)

export default component.exports